export default "__VITE_ASSET__btaEhqVB__"